import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import "./AuthStyles.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Login function
  const loginHandler = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter email and password");
      return;
    }

    setIsLoading(true);

    try {
      const data = { email, password };
      
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/users/login`,
        data
      );

      toast.success(res.data.msg || "Login Successful");
      localStorage.setItem("todoapp", JSON.stringify(res.data));
      navigate("/home");
      console.log("Login response:", res.data);
    } catch (err) {
      console.error("Login error:", err);

      if (err.response && err.response.data && err.response.data.msg) {
        toast.error(err.response.data.msg);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <Toaster position="top-right" toastOptions={{
        style: {
          borderRadius: '12px',
          background: '#333',
          color: '#fff',
        },
      }} />
      
      {/* Animated background elements */}
      <div className="bg-orb orb-1"></div>
      <div className="bg-orb orb-2"></div>
      <div className="bg-orb orb-3"></div>
      
      <div className="form">
        <div className="form-header">
          <div className="icon-wrapper">
            <i className="fa-solid fa-circle-user"></i>
          </div>
          <h2>Welcome Back</h2>
          <p className="subtitle">Please login to your account</p>
        </div>

        <form onSubmit={loginHandler}>
          <div className="input-group">
            <div className="input-wrapper">
              <i className="fa-solid fa-envelope input-icon"></i>
              <input
                type="email"
                className="form-control"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="input-group">
            <div className="input-wrapper">
              <i className="fa-solid fa-lock input-icon"></i>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i 
                className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password`}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>
          </div>

          <div className="form-options">
            <label className="remember-me">
              <input type="checkbox" />
              <span>Remember me</span>
            </label>
            <Link to="/forgot-password" className="forgot-link">
              Forgot password?
            </Link>
          </div>

          <button 
            type="submit" 
            className="auth-btn" 
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                <span>Logging in...</span>
              </>
            ) : (
              <>
                <span>Login</span>
                <i className="fa-solid fa-arrow-right"></i>
              </>
            )}
          </button>

          <div className="divider">
            <span>or continue with</span>
          </div>

          {/* <div className="social-login">
            <button type="button" className="social-btn google">
              <i className="fa-brands fa-google"></i>
            </button>
            <button type="button" className="social-btn github">
              <i className="fa-brands fa-github"></i>
            </button>
            <button type="button" className="social-btn apple">
              <i className="fa-brands fa-apple"></i>
            </button>
          </div> */}

          <p className="form-footer">
            Don't have an account? 
            <Link to="/register" className="link-primary">Sign up</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;